import type { Message } from '@/api/types';
import type { SequenceProblem } from '@/crypto';
import { t } from '@/i18n';

/** The envelope of a message: it sits in `body` for a text and in `header` for a file. */
export function envelopeOf(message: Message): string {
  return message.kind === 'text' ? message.body : message.header;
}

/** The sentence for a notice about the order of a bridge's messages, or null when nothing is wrong. */
export function orderNotice(problems: readonly SequenceProblem[]): string | null {
  if (problems.length === 0) return null;
  if (problems.includes('missing')) return t('order.missing');
  if (problems.includes('altered')) return t('order.altered');
  return t('order.reordered');
}
